const bleExtensionMessageType = {
    startScan: "startScan",
    stopScan: "stopScan",
    isScanning: "isScanning",
    discoveredDevices: "discoveredDevices",
    connectedDevices: "connectedDevices",
    retrieveDevices: "retrieveDevices",
    centralState: "centralState",  
    connect: "connect",
    disconnect: "disconnect",
    connectionStatus: "connectionStatus",
    services: "services",
    characteristicsForService: "characteristicsForService",
    writeCharacteristicValue: "writeCharacteristicValue",
    readCharacteristicValue: "readCharacteristicValue",
    getCharacteristicValue: "getCharacteristicValue",
    setCharacteristicNotifyValue: "setCharacteristicNotifyValue",
    readRSSI: "readRSSI",
    getRSSI: "getRSSI",
    writeDescriptorValue: "writeDescriptorValue",
    readDescriptorValue: "readDescriptorValue",
    getDescriptorData: "getDescriptorData",
    popStoredCharacteristicNotifyValue: "popStoredCharacteristicNotifyValue",
    popStoredCharacteristicData: "popStoredCharacteristicData",
    popStoredCharacteristicWriteValueError: "popStoredCharacteristicWriteValueError",
    checkExtensionAvailability: "checkExtensionAvailability",
}

export default bleExtensionMessageType;